import React, { useCallback } from 'react';
import { businessFilterStyles } from './styled';
import { SegmentedButton } from '@ontruck/orc';
import cx from 'classnames';

export const options = {
  ftl: { value: 'FTL', label: 'FTL' },
  ltl: { value: 'LTL', label: 'LTL' },
};

const BusinessFilter = ({ className, value, onChange, marginRight }) => {
  const handleChange = useCallback(
    (_, { value: selectedValue }) => {
      onChange(selectedValue);
    },
    [onChange]
  );

  const handleClick = useCallback(
    (optionValue) => () => {
      if (optionValue === value) {
        onChange(null);
      }
    },
    [value, onChange]
  );

  return (
    <div className={cx(className, { 'margin-right': marginRight })}>
      <SegmentedButton.Parent value={value} onChange={handleChange}>
        <SegmentedButton.Child
          onClick={handleClick(options.ftl.value)}
          value={options.ftl.value}
          label={options.ftl.label}
        />
        <SegmentedButton.Child
          onClick={handleClick(options.ltl.value)}
          value={options.ltl.value}
          label={options.ltl.label}
        />
      </SegmentedButton.Parent>
    </div>
  );
};

BusinessFilter.filterName = 'BusinessFilter';

export default businessFilterStyles(BusinessFilter);
